import React from 'react';
import Heading from '../ui/Heading';
import Section from '../ui/Section';
import NearbyAmenities from './NearbyAmenities';

const ProjectLocation = ({ location }) => {
  return (
    <Section className="bg-white py-10 sm:py-16 sm:px-5 lg:px-10">
      <div className="mx-auto">
        <Heading level="3">Location</Heading>
        <div className="grid grid-cols-1 md:grid-cols-2 items-start gap-10 mt-10">
          <div className="h-96 w-full rounded-lg overflow-hidden shadow-md">
            {/* Map integration */}
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3186.032044140286!2d77.766937!3d12.836843999999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTLCsDUwJzEyLjYiTiA3N8KwNDYnMDEuMCJF!5e1!3m2!1sen!2sin!4v1743586761364!5m2!1sen!2sin" 
              className="w-full h-full border-0" 
              title="Google Maps Location of Vasudharini Nest"
              allowFullScreen 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade">
            </iframe>

          </div>
          <div className='m-auto'>
            <p className="text-gray-700 sm:text-lg leading-relaxed">{location.description}</p>
              <p className="my-5 text-gray-600 font-medium text-sm sm:text-base">
                <span className="font-normal">Rera No: </span> PRM/KA/RERA/1251/308/PR/120625/007818
              </p>
            
            <div className=" mb-6">
              <h4 className=" text-xl mb-1 text-gray-800">Address</h4>
              <p className="whitespace-pre-line sm:text-lg text-gray-600">{location.address}</p>
            </div>
            
            {/* New Amenities Section */}
          </div>
        </div>
            <NearbyAmenities amenities={location.amenities} />
      </div>
    </Section>
  );
};

export default ProjectLocation;